<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card>
        <div class="grid_flex pl-3 pt-5 pr-3">
          <div class="pr-3"><b>ยอดรวมเครดิตของลูกค้าทั้งหมด</b></div>
          <div><b class="pr-2" style="color: #86bc3a;">{{ format_price(total) }}</b>฿</div>
        </div>
        <v-card-title>
          <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
        </v-card-title>
        <div class="pa-3">
          <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>
                  <div>{{ dataDetail.item.order_code }}</div>
                </td>
                <td>
                  <div>{{ dataDetail.item.customer_name }}</div>
                </td>
                <td>
                  <div>{{ dataDetail.item.start_date }}</div>
                </td>
                <td>
                  <div>{{ format_price(dataDetail.item.total) }}</div>
                </td>
                <td class="pa-3">
                  <v-btn class="pa-6 grad-success-bg white--text" @click="debtor_detail(dataDetail.item.id)">
                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {formatPrice} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Report_debtor",
  data() {
    return {
      loading_page: false,
      search: '',
      total: 0,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'เลขที่วางบิล',
          value: 'order_code',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ชื่อลูกค้า',
          value: 'customer_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'วันที่เริ่มเปิดยอด',
          value: 'start_date',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ยอดชำระหนี้',
          value: 'total',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/debtors/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.total = res.data.object.total
              this.data_list = res.data.object.orderlists
            }
          })
    },
    debtor_detail(code) {
      this.$router.push('/creditor/reportdebtordetail/' + code)
    }
  },
  mounted() {
    this.get_data()
  },
}
</script>

<style scoped>
.grid_flex {
  display: flex;
  font-size: 24px !important;
  justify-content: right;
}
@media only screen and (max-width: 1180px) {
  .grid_flex {
    display: flex;
    font-size: 20px !important;
    justify-content: right;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    font-size: 20px !important;
    text-align: center;
  }
}
</style>
